export class Constants {
  static title = 'Evoca Middleware';
  static snackbarDuration = 3000;
  static defaultLanguage = 'en';
  static superAdmin = 'Superadmin Evoca';
  static superAdminRole = 'superadmin_evoca';
  static technicianRole = 'technician';
  static operatorRole = 'operator';
}
